import styled from "styled-components";
import { INPUTS } from "@etiquette-ui/colors";
import FormSection from "containers/Form/FormSection";

export const PresentationBody = styled.div`
  @media ( max-width: 768px ) {
    background: white;
    border-radius: 8px;
    width: 95%;
    margin: auto;
    padding-top: 10px;
    padding-bottom: 25px;
    margin-bottom: 10px;
    overflow: hidden;
  }
`;

export const CustomFormSection = styled(FormSection)`
  width: 100%;
  @media( max-width: 768px ) {
    padding: 15px;
    position: relative;

    &::after {
      content: '';
      bottom: -5px;
      left: 5%;
      right: 5%;
      max-width: 90%;
      position: absolute;
      border-top: 2px solid ${INPUTS};
    }
  }
`;

export const PresentationSection = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  padding-top: 10px;
  margin-top: -15px;
  margin-bottom: 25px;

  @media( max-width: 768px ) {
    margin-bottom: 0px;
    margin-top: 15px;
  }
`;

export const TitleContainer = styled.div`
  margin-bottom: 15px;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

export const InputsContainer = styled.div`
  display: flex;
  flex: 0 0 100%;
  max-width: 100%;
  flex-wrap: wrap;

  .pricing-method {
    flex: 0 0 100%;
    max-width: 100%;
    min-width: 300px;
    margin-bottom: 10px;
  }

  .price,
  .pos-code {
    flex: 0 0 50%;
    max-width: 50%;
    min-width: 200px;
    margin-bottom: 10px;
  }

  .price {
    padding-right: 5px;
  }

  @media (min-width: 768px) {
    flex: 0 0 75%;
    max-width: 75%;

    .pricing-method {
      flex: 0 0 33%;
      max-width: 350px;
      margin-right: 10px;
    }

    .price,
    .pos-code {
      padding: 0px;
      flex: 0 0 25%;
      max-width: 250px;
      margin-right: 10px;
    }
    .pos-code {
      padding-left: 5px;
    }
  }
`;

export const NameContainer = styled.div`

  max-width: 100%;
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;
  
  .presentation-name {
    flex: 0 0 100%;
    max-width: 350px;
    margin-bottom: 10px;
  }
  
  @media (min-width: 768px) {
    max-width: 700px;
    flex: 0 0 65%;
    margin-right: 10px;
    
    .presentation-name {
      flex: 0 0 50%;

      &:nth-child(1){
        padding-right: 5px;
      }

      &:nth-child(2) {
        padding-left: 5px;
      }
    }
  }
`;